import styled from 'styled-components';

import { pxToRem } from 'utils/convert';
import { spacing, body2, colors } from 'ui/theme';
import { Search } from 'ui/icons';
import { Spinner } from 'ui/spinner';
import { Table } from 'ui/table';
import { InputText } from 'ui/inputs';
import { PaginationFooter } from 'ui/paginationFooter';
import { TABLE_CELL_VARIANTS } from './TableSelect.constants';

const BORDER_COLOR = colors.grey15;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${colors.backgroundScreen};
`;

export const StyledTable = styled(Table)`
  border-bottom: ${pxToRem(1)} solid ${BORDER_COLOR};
  position: relative;
`;

export const TableCell = styled.div.attrs(() => ({
  role: 'cell',
}))`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
  color: ${({ variant }) =>
    variant === TABLE_CELL_VARIANTS.MAIN ? colors.textPrimary : colors.textSecondary};
`;

export const RadioCell = styled(TableCell)`
  svg {
    display: flex;
  }
`;

export const TableSelectWrapper = styled.div`
  [role='columnheader'] {
    padding-top: ${spacing.base};
    padding-bottom: ${spacing.base};
  }
  [role='row'] {
    cursor: pointer;
  }
  [role='cell'] {
    vertical-align: middle;
  }
`;

export const TableSelectHeaderBar = styled.div`
  padding: ${spacing.base} ${spacing.plusHalf};
  border-top: ${pxToRem(1)} solid ${BORDER_COLOR};
  border-bottom: ${pxToRem(1)} solid ${BORDER_COLOR};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TableSelectBarChildrenWrapper = styled.div`
  flex: 1 1 auto;
`;

export const TableSelectSearch = styled(InputText)`
  width: ${pxToRem(231)};
  flex: 0 1 auto;
`;

export const TableSelectSearchIcon = styled(Search)`
  color: ${colors.textSecondary};
`;

export const TableEmptyStateWrapper = styled.div`
  text-align: center;
  padding: ${spacing.plusHalf} ${spacing.base};
  background-color: ${colors.grey1};
  border-bottom: ${pxToRem(1)} solid ${BORDER_COLOR};
`;

export const StyledPaginationFooter = styled(PaginationFooter)`
  padding: ${spacing.plusHalf} ${spacing.half};
`;
